import { type FC } from 'react';
import SV from 'server-vars';
import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker.tsx';
import { trackClientError } from 'dibs-tracking/exports/prometheus.ts';

type Props = {
    rumTransactionName?: string;
    monitoringGroupName?: string;
    error?: Error | null;
};

export const TrackErrorPageView: FC<Props> = ({
    rumTransactionName,
    monitoringGroupName,
    error,
}) => {
    return (
        <VisibilityTracker
            onVisibilityChange={({ isVisible, disconnect }) => {
                /**
                 * It's possible that this error page is rendered, but not visible to the user.
                 * e.g. Pre-rendered checkout.
                 */
                if (isVisible) {
                    trackClientError({
                        rumTransactionName:
                            rumTransactionName || SV.get('rumTransactionName') || 'unknown',
                        monitoringGroupName:
                            monitoringGroupName || SV.get('monitoringGroupName') || 'unknown',
                        errorMessage: error?.message || 'unknown',
                        errorName: error?.name || 'unknown',
                        errorStack: error?.stack || 'unknown',
                    });
                    disconnect();
                }
            }}
        />
    );
};
